import { render, staticRenderFns } from "./PeriodOfConstructionFormPart.vue?vue&type=template&id=a46a28b6"
import script from "./PeriodOfConstructionFormPart.vue?vue&type=script&lang=js"
export * from "./PeriodOfConstructionFormPart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports